import { render, staticRenderFns } from "./title-bar.vue?vue&type=template&id=f4d0dfae&scoped=true&"
import script from "./title-bar.vue?vue&type=script&lang=js&"
export * from "./title-bar.vue?vue&type=script&lang=js&"
import style0 from "./title-bar.vue?vue&type=style&index=0&id=f4d0dfae&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f4d0dfae",
  null
  
)

export default component.exports